import axios from "axios";
import { ProticoClient } from "protico-sdk";
import { getSecrets } from "../../config";

// Config global defaults for axios/django
const { BACKEND_URL } = getSecrets();

// Set baseURL from secrets
axios.defaults.baseURL = BACKEND_URL;

// Config global defaults for axios/django
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";

/**
 * Available endpoints
 * */
export const API_GET_IS_ADMIN = "/api/isadmin/";
export const API_POST_WWW_COMBINE = "/api/post-www-combine/";
export const API_PUT_PATCH_WHITEBOARD_URL = "/api/v1/patch/whiteboard/url/";
export const API_GET_NFT_LIST = "/api/check_nft_list/";
export const API_GET_DM_NFT_LIST = "/api/check_dm_nft_list/";
export const API_QUICKNODE_API = "/api/quicknode-api/";
export const API_GET_LOGO = "/api/domain-logo/";
export const API_ALCHEMY_API = "/api/alchemy-api/";
export const API_ALCHEMY_COLLECTION_API = "/api/alchemy-collection-api/";
export const API_GET_REAL_DOMAIN = "/api/demo-app-id/";
export const API_GET_IN_APP_ADS = "/api/ads-in-app-recommandation/";
export const API_POST_B_TO_C_READ = "/api/b-to-c-message/read/";
export const API_POST_GOOGLE_LOGIN = "/api/google-login/";
export const API_POST_GOOGLE_LOGIN_UPDATE = "/api/google-login-update/";
export const API_GET_POLL_LIST = "/api/vote/";
export const API_POST_POLL_RESULT = "/api/poll-result/";
export const API_POST_IOS_WALLET_LINK = "/api/ios/pass/new/";
export const API_POST_GOOGLE_WALLET_LINK = "/api/google/pass/new/";
export const API_GET_MINTED_NFT_LIST = "/api/minted-nfts/";
export const API_GET_NOTIFICATION_UNREAD = "/api/d2c-unread-message-count/";
export const API_POST_AVATAR_UPLOAD_START = "/api/update-dapp-avatar/start/";
export const API_POST_ENGAGEMENT_EVENT = "/api/engagement-event/";
export const API_POST_HOT_MESSAGE = "/api/whiteboard/hot/";
export const API_GET_MESSAGE_TAG = "/api/whiteboard/tag/";
export const API_GET_MESSAGE_THREAD = "/api/whiteboard/thread/";
export const API_POST_DAPP_IMAGE = "/api/dapp-image/upload/start/";
export const API_POST_DAPP_IMAGE_FINISH = "api/dapp-image/upload/finish/";
export const API_GET_LATEST_MESSAGE_TIME = "/api/latest-whiteboard-message/";
export const API_GET_FOLLOW_LIST = "/api/follow/";
export const API_GET_ARTICLE_RECOMMENDATION = "/api/article-recommendation/";
export const API_POST_PAYMENT_INTENT = "/api/create-payment-intent/";
export const API_GET_USER_SUPERCHAT = "/api/get-user-super-chat/";
export const API_GET_USER_ROOM_LIST = "/api/user-room-list/";

export default axios;

let proticoClient: ProticoClient;
export const getProticoClient = () => {
  if (!proticoClient) {
    const { BACKEND_URL, ANALYTICS_URI } = getSecrets();

    let analyticsUri = ANALYTICS_URI;

    // Only apply the 10% split if ANALYTICS_URI is the production URL
    if (ANALYTICS_URI === "https://client.protico.io/production/collect") {
      // 10% chance to use Protico analytics
      if (Math.random() < 0.5) {
        analyticsUri = "https://analytics.protico.io/production/collect";
      }
    }
    proticoClient = new ProticoClient(BACKEND_URL, analyticsUri);
  }
  return proticoClient;
};

export function createClickEngagementRecorder(
  roomUrl: string,
  roomDomain: string
) {
  return async function recordClickEvent(clickType: string) {
    try {
      await getProticoClient().engagement.recordClickEvent({
        url: roomUrl,
        click_data: {
          click_type: clickType,
          domain: roomDomain,
        },
      });
    } catch (error) {
      console.error("Error recording engagement event:", error);
    }
  };
}
